import { useEffect, useRef, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Cursor() {
    const mx = useMotionValue(-100);
    const my = useMotionValue(-100);
    const sx = useSpring(mx, { stiffness: 500, damping: 40, mass: 0.5 });
    const sy = useSpring(my, { stiffness: 500, damping: 40, mass: 0.5 });
    const [mode, setMode] = useState(""); // "", "view"

    useEffect(() => {
        const move = (e) => {
            mx.set(e.clientX);
            my.set(e.clientY);
        };
        const over = (e) => {
            const t = e.target.closest?.("[data-cursor='view']");
            setMode(t ? "view" : "");
        };
        window.addEventListener("mousemove", move);
        window.addEventListener("mouseover", over);
        return () => {
            window.removeEventListener("mousemove", move);
            window.removeEventListener("mouseover", over);
        };
    }, [mx, my]);

    return (
        <motion.div
            className={`cursor-dot hidden md:flex items-center justify-center ${mode === "view" ? "hover-view" : ""}`}
            style={{ x: sx, y: sy }}
            data-testid="cursor-follower"
        >
            <span className="view-label">VIEW</span>
        </motion.div>
    );
}
